<pbc-filter [config]="ErforderlichesDokumentsFilterConfig" [filter]="erforderlichesDokuments.filter$ | async" (filterChange)="erforderlichesDokuments.filter$.next($event)"></pbc-filter>
